export const REACT_APP_GOOGLE_API_KEY = 'AIzaSyBeLdkRXDOc9h__lx0Q9KV0NteZjXbrKhE'
export const REACT_APP_GOOGLE_SHEETS_ID = '1kO0J6h6HiD9Pt84mjKedgPE0t37aWLnxecfHLic0rQw';